import { makeStyles } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import _ from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { Link } from 'react-router-dom'

import { endpoints } from '../../../api'

export default function PatientSearch({ styles }) {
  const [searchQuery, setSearchQuery] = useState('Search clients')
  const [showResults, setShowResults] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const useStyles = makeStyles(styles)
  const classes = useStyles()

  const { data, refetch } = useQuery(
    [endpoints.getPatientSearch.getCacheId(), searchQuery],
    ({ queryKey }) =>
      endpoints.getPatientSearch.request({
        search: queryKey[1]
      }),
    {
      enabled: false,
      initialData: []
    }
  )

  const throttledSearch = _.throttle(() => refetch(), 150)

  useEffect(() => {
    if (searchQuery.length >= 1) {
      throttledSearch()
    }
  }, [searchQuery])

  const formattedSearchData = useMemo(() => {
    return data.map(patient => {
      patient.name = `${patient.first_name} ${patient.last_name}`
      return patient
    })
  }, [data])

  // this is a HACK to get arrow keys and enter to select a client and navigate
  // the alternative is to use a different search library but this feels isolated enough for now
  const handleKeyDown = e => {
    if (e.keyCode === 40) {
      // down arrow
      const results = document.querySelectorAll('a[class^="result"]')
      if (results && selectedIndex < results.length - 1) {
        setSelectedIndex(selectedIndex + 1)
      }
    } else if (e.keyCode === 38 && selectedIndex > 0) {
      // up arrow
      e.preventDefault() // this is to prevent the cursor from going to the beginning of the query
      setSelectedIndex(selectedIndex - 1)
    } else if (e.keyCode === 13) {
      // "Enter" key
      const highlightedResult =
        document.querySelectorAll('a[class*="active"]')[0]
      if (highlightedResult) {
        highlightedResult.click()
        document.getElementById('search-patients').blur()
      }
    }
  }

  return (
    <div className={classes.searchBar}>
      <label aria-label="search-patients">
        <TextField
          id="search-patients"
          className="outlinedInput"
          type="search"
          onChange={e => {
            setSelectedIndex(0)
            setSearchQuery(e.target.value)
          }}
          onFocus={() => setShowResults(true)}
          onBlur={() => setTimeout(() => setShowResults(false), 200)} // add a delay here to allow click events to fire
          onKeyDown={handleKeyDown}
          placeholder="Search clients"
          fullWidth
          variant="outlined"
          autoComplete="off"
        />
      </label>
      {showResults && (
        <div className="results">
          {formattedSearchData.map((patient, index) => (
            <Link
              class={`result ${selectedIndex === index && 'active'}`}
              data-tracking-text={`[Search Results]`}
              key={patient.id}
              to={`/patient/${patient.id}`}
              onMouseDown={e => {
                if (e.button === 2) e.preventDefault()
              }} // prevent right-click from blurring input
            >
              <div>
                {patient.name}
                <span className="archived">
                  {patient.is_archived && 'DISCHARGED'}
                </span>
              </div>
              <div className="email">{patient.email}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
